import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const RawCallLogs = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchLogs = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}calls/list/`);
            setLogs(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching logs:", error);
            setError(error.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, []);

    return (
        <div style={{ padding: '2rem' }}>
            <h2 style={{ color: '#1e293b', marginBottom: '1.5rem' }}>Raw Webhook Payloads (Debugger)</h2>
            
            {error && (
                <div style={{ padding: '1rem', backgroundColor: '#fee2e2', color: '#dc2626', borderRadius: '8px', marginBottom: '1rem' }}>
                    {error}
                </div>
            )}

            {loading ? (
                <p>Loading data...</p>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {logs.length > 0 ? logs.map((log) => (
                        <div key={log.id} style={{ 
                            backgroundColor: '#1e293b', 
                            color: '#e2e8f0', 
                            borderRadius: '8px', 
                            padding: '1rem',
                            fontFamily: 'monospace',
                            fontSize: '0.875rem'
                        }}>
                            <div style={{ borderBottom: '1px solid #334155', paddingBottom: '0.5rem', marginBottom: '0.5rem', display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ color: '#94a3b8' }}>ID: {log.external_id}</span>
                                <span style={{ color: '#10b981' }}>{new Date(log.call_time).toLocaleString()}</span>
                            </div>
                            <pre style={{ margin: 0, overflowX: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                {JSON.stringify(log, null, 2)}
                            </pre>
                        </div>
                    )) : (
                        <p style={{ textAlign: 'center', color: '#64748b' }}>No data available.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default RawCallLogs;
